<script setup lang="ts">

import {onMounted, ref} from "vue";
import CustomButton from "@/components/Button/Button.vue";
import { useRouter } from 'vue-router';
import {useDestinationStore} from "@/stores/destinationStore";
import {VueSpinner} from "vue3-spinners";

const destinationStore = useDestinationStore();

const router = useRouter();



onMounted(() => {
  destinationStore.getAllDestinations();
});

</script>



<template>
  <div class="container place-content-center items-center pt-24">
    <div class="responsive-title-1 text-center text-primary-darkBlue font-thin">Destinations</div>
    <div v-if="destinationStore.loading" class="grid place-content-center mt-10">
      <VueSpinner size="30" color="#beA5aa" />
    </div>

    <div v-else class="pt-17 flex flex-col gap-4">

      <!-- Desktop -->
      <div class="hidden sm:grid lg:grid-cols-2 lg:grid-rows-3 gap-4 lg:max-h-[1000px]">
        <div
            v-for="(destinationItem, index) in destinationStore.allDestinations.slice(0,4)"
            :key="index"
            :class="[
              index % 2 === 0 ? 'lg:row-span-2' : 'lg:row-span-1',
              'break-inside-avoid'
            ]"
        ><!--       index % 2 === 0 ? 'row-span-2' : 'row-span-1', -->
          <div class="relative overflow-hidden group h-full cursor-pointer"
               @click="destinationStore.viewDestination(destinationItem.slug, '')"
          >
            <img
                :src="destinationItem.image"
                alt="Destination"
                class="w-full h-full object-cover brightness-70 duration-500 group-hover:scale-105"
            />
            <div class="absolute inset-0 flex flex-col justify-center items-center text-center p-6 text-white z-10">
              <h2 class="responsive-title-6 font-bold mb-2 group-hover:responsive-title-5">
                {{ destinationItem.generalLocation }}
              </h2>
              <div>
              <span
                  v-for="(destination, idx) in destinationItem.destinations"
                  :key="idx"
                  class="responsive-body-medium group-hover:responsive-body-large"
              >
                {{ destination.name }}<span v-if="idx < destinationItem.destinations.length - 1">, </span>
              </span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Mobile -->
      <div class="sm:hidden flex flex-col gap-8">
        <div class="flex gap-5 overflow-x-auto">
          <div
              v-for="(destinationItem, index) in destinationStore.allDestinations.slice(0,4)"
              :key="index"
              class="flex flex-col gap-2 min-w-[320px]"
              @click="destinationStore.viewDestination(destinationItem.slug, '')"

          >
            <div class=" min-h-[300px] relative aspect-w-4 h-60 mb-2 overflow-hidden group cursor-pointer">
              <img
                  :src="destinationItem.image"
                  alt="Destination"
                  class="w-full h-full object-cover brightness-70 duration-500 group-hover:scale-105"
              />
              <div class="absolute inset-0  items-center text-center place-content-center p-6 text-white z-10">
                <h2 class="responsive-title-6 font-bold mb-2 group-hover:responsive-title-5">{{ destinationItem.generalLocation }}</h2>
                <span
                    v-for="(destination, idx) in destinationItem.destinations"
                    :key="idx"
                    class="mt-1 responsive-body-medium group-hover:responsive-body-large"
                >
                    {{ destination.name }}<span v-if="idx < destinationItem.destinations.length - 1">, </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="mt-17 text-center" v-if="!destinationStore.loading">
      <CustomButton
          type="gradient"
          :outlined="true"
          size="medium"
          :shadow="false"
          class="px-4"
          @click="router.push('/destinations')"
      >
        SEE ALL DESTINATIONS
      </CustomButton>
    </div>
  </div>
</template>


<style scoped>

</style>
